<template>
    <submenu-page
        eyebrow="PEOPLE MANAGEMENT"
        title="Staff Management"
        description="Manage staff profiles, performance reviews and leave requests."
        count-label="staff tools"
    >
        <SubMenu />
    </submenu-page>
</template>
<script>


import SubMenu from './SubMenu.vue';
export default {
  components: {
    SubMenu
  },
  data() {
    return {
      accessDetails: null,
    };
  },
  mounted() {
    this.accessDetails = this.$store.getters['auth/_user'];   
    if (this.accessDetails.isSchoolStaff == false) {
      this.$store.dispatch('auth/Logout')
      this.$router.push('/login')
    }
  }
};
</script>
<style></style>
